import type { IntlShape } from "react-intl"
import { pricingFieldMessages } from "../hooks/pricingField.messages"
import type { AustraliaNetPricePricingFields } from "./australiaNetPricePricing.fields"
import { australiaNetPricePricingFieldNames } from "./australiaNetPricePricing.fields"

export const getAustraliaNetPricePricingFields = (
	isDraft: boolean,
	formatMessage: IntlShape["formatMessage"],
): AustraliaNetPricePricingFields => {
	return {
		minimumPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: australiaNetPricePricingFieldNames.minimumPriceName,
			type: "currency",
		},
		netPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.netPriceLabel),
			name: australiaNetPricePricingFieldNames.netPriceName,
			type: "currency",
		},
		price: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.customerPriceLabel),
			maxLength: 15,
			name: australiaNetPricePricingFieldNames.priceName,
			required: true,
			type: "currency",
		},
		purchasePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: australiaNetPricePricingFieldNames.purchasePriceName,
			type: "currency",
		},
		vatDeductible: {
			label: formatMessage(pricingFieldMessages.vatDeductibleLabel),
			name: australiaNetPricePricingFieldNames.vatDeductibleName,
		},
	}
}
